import Button from "../../UI/Button";
import Checkbox from "../../UI/Checkbox";
import IconButton from "../../UI/IconButton";
import getClassNames from "../../../utils/getClassNames";
import { INCLUDE_HOUSEHOLD_MEMBERS } from "../../../constants/reportStep";
import ReportStepProps from "./ReportStepProps";

const IncludeHouseholdMembers = (props: ReportStepProps) => {
    const includeHouseholdMembers = props.values.find(value => value.name === 'include_household_members')?.value === 'true';

    return <div className={getClassNames('report-step', props.expanded ? 'expanded' : '')}>
        <div className="report-step-header">
            <div className="row justify-content-between align-items-center">
                <div className="column-auto">
                    <h3>Include Household Member Demographics?{includeHouseholdMembers ? ' - Yes' : ''}</h3>
                </div>
                <div className="column-1">
                    <IconButton id="toggle-include-household-members-expansion"
                        className="small flat"
                        disabled={props.disabled}
                        icon={props.expanded ? <i className="ri-arrow-up-s-line" /> : <i className="ri-arrow-down-s-line" />}
                        onClick={() => props.onExpand(INCLUDE_HOUSEHOLD_MEMBERS, !props.expanded)} />
                </div>
            </div>
        </div>
        <div className="report-step-body">
            <div className="row margin-bottom-3">
                <div className="column">
                    <Checkbox id="include-household-members"
                        label="Include household member demographics in this report"
                        checked={includeHouseholdMembers}
                        disabled={props.disabled}
                        onChange={checked => props.onChange({
                            step: INCLUDE_HOUSEHOLD_MEMBERS,
                            values: [{ name: 'include_household_members', value: checked.toString() }]
                        })} />
                    <p className="text-sub">Demographic summaries will include data you have stored about participants and all of their household members.</p>
                </div>
            </div>
            <div className="row justify-content-end margin-bottom-3">
                <div className="column-auto">
                    <Button id="include-household-members-next"
                        text="Next"
                        icon={<i className="ri-arrow-right-s-line" />}
                        iconLocation="end"
                        className="secondary"
                        disabled={props.disabled}
                        onClick={() => props.onNext(INCLUDE_HOUSEHOLD_MEMBERS)} />
                </div>
            </div>
        </div>
    </div>;
};

export default IncludeHouseholdMembers;
